import axios from "axios";
import { WHATSAPP_GATEWAY } from "../Constant";

// Dedicated axios instance for the WhatsApp Gateway (separate from the main API server)
const gatewayClient = axios.create({
  baseURL: WHATSAPP_GATEWAY,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 5000,
});

// ─── Types ───────────────────────────────────────────────────────────────────

export interface GatewayStatusResponse {
  status: "INITIALIZING" | "QR" | "READY" | "AUTH_FAILURE" | "DISCONNECTED" | "OFFLINE";
  qr?: string;
  enabled: boolean;
  connectedAt: string | null;
  uptimeSeconds: number | null;
  totalMessages: number;
}

export interface ActivityLogEntry {
  from: string;
  body: string;
  replied: boolean;
  timestamp: string;
}

export interface ActivityLogsResponse {
  logs: ActivityLogEntry[];
}

// ─── API Functions ────────────────────────────────────────────────────────────

export const GetWhatsAppGatewayStatus = async (): Promise<GatewayStatusResponse> => {
  try {
    const response = await gatewayClient.get<GatewayStatusResponse>("/status");
    return response.data;
  } catch {
    return {
      status: "OFFLINE",
      enabled: false,
      connectedAt: null,
      uptimeSeconds: null,
      totalMessages: 0,
    };
  }
};

export const GetWhatsAppActivityLogs = async (): Promise<ActivityLogsResponse> => {
  try {
    const response = await gatewayClient.get<ActivityLogsResponse>("/logs");
    return response.data;
  } catch {
    return { logs: [] };
  }
};

export const PostWhatsAppLogout = async (): Promise<{ success: boolean; message: string }> => {
  try {
    const response = await gatewayClient.post<{ success: boolean; message: string }>("/logout");
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Logout request failed.",
    };
  }
};

export const PostWhatsAppToggle = async (
  enabled: boolean
): Promise<{ success: boolean; enabled: boolean }> => {
  try {
    const response = await gatewayClient.post<{ success: boolean; enabled: boolean }>("/toggle", {
      enabled,
    });
    return response.data;
  } catch (error: any) {
    return { success: false, enabled };
  }
};
